import React from "react";
import "./About.css";
import profile from "../assets/profile img2.jpeg"; // optional

function About() {
  return (
    <section className="about-section" id="about">
      {/* TOP TITLE */}
      <h1 className="about-title reveal delay">
        About <span>Me</span>
      </h1>

      {/* NAVBAR (INSIDE ABOUT PAGE LIKE IMAGE) */}
      {/* <ul className="about-nav">
        <li>Home</li>
        <li className="active">About</li>
        <li>Education</li>
        <li>Skills</li>
        <li>Contact</li>
      </ul> */}

      {/* PROFILE IMAGE */}
      <div className="about-image reveal delay-1">
        <img src={profile} alt="Profile" />
      </div>

      {/* CONTENT */}
      <div className="about-content reveal delay-2">
        <h2>Hi there! Glad to see you here.</h2>

         <p>My name is Keerthana Selvam. I completed my Bachelor's degree in Information Technology. I am currently pursuing my Master's degree in Information Technology through distance education at Alagappa University.

To enhance my technical skills, I am currently pursuing a Python Full Stack Development course. During my undergraduate studies, I completed a Frontend Developer internship, where I gained around seven months of hands-on experience. During this internship, I worked with frontend technologies, contributed to real-world tasks, and learned about the software development lifecycle, team collaboration, and professional work culture.

My technical skills include HTML, CSS, JavaScript, Bootstrap, React.js, Git, and GitHub. I am also currently learning Python Full Stack Development to strengthen my backend development skills.

I am passionate about web development and enjoy building responsive, user-friendly, and interactive web applications. I am a quick learner, a good team player, and always eager to learn new technologies and take on new challenges.

Now, I am seeking an opportunity where I can apply my knowledge, contribute to the organization's success, and continue growing as a software developer. Thank you.
        </p>

        {/* <button className="about-btn reveal delay-4" href="#contact"> Contact Me</button> */}
      <a
              href="#contact"
              className="btn secondary"
            >
              Any Questions
            </a>
      </div>
    </section>
  );
}

export default About;
